export default "__VITE_ASSET__Bx5MMuKx__"